"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../../assets/Button.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _pano = _interopRequireDefault(require("../../assets/Theme1Img/pano.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Button["default"]);

var Button = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Button, _React$PureComponent);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return _this.renderBtn();
    });

    return _this;
  }

  var _proto = Button.prototype;

  _proto.renderBtn = function renderBtn(isClick) {
    if (isClick === void 0) {
      isClick = true;
    }

    var _this$props = this.props,
        src = _this$props.src,
        activity = _this$props.activity,
        children = _this$props.children,
        onClick = _this$props.onClick,
        style = _this$props.style,
        _this$props$ui = _this$props.ui,
        ui = _this$props$ui === void 0 ? {} : _this$props$ui;
    var imgStyle = {}; // if (src) {
    //   imgStyle.backgroundImage = `url('${src ? src : pano}')`;
    // } else {
    //   imgStyle.backgroundPositionY = position;
    // }

    imgStyle.backgroundImage = "url('" + (src ? src : _pano["default"]) + "')";
    return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
      layout: "vertical",
      horizontal: "center",
      className: cx("CustomButton"),
      onClick: isClick ? onClick : null,
      style: style
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("CustomButtonImgBox")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: imgStyle,
      className: cx("CustomButtonImg"),
      alt: ""
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: ui.fontColor,
        borderColor: activity ? ui.fontAvtiveColor : "transparent"
      },
      className: cx("CustomButtonTitle", {
        activity: activity
      })
    }, children));
  };

  return Button;
}(_react["default"].PureComponent);

var _default = Button;
exports["default"] = _default;
module.exports = exports.default;